/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { set } from 'lodash-es';

import downloadFromUrl from '@/services/helpers/download';

import {
  findSignatureUrlFromId as _findSignatureUrlFromId,
} from '@/services/api/document/document';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
  downloadFromUrl(unset, { downloadLink, name }) {
    const link = document.createElement('a');

    link.href = downloadLink;
    link.setAttribute('download', name);

    const app = document.getElementById('app');
    app.appendChild(link);
    link.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(link);
      link.remove();
    }, 500);
    return Promise.resolve();
  },
  getDocument(unset, document) {
    const path = `documents/${document.documentId}/download`;
    const { fileName: name } = document;
    return downloadFromUrl({ path, name });
  },
  downloadPolicy({ rootGetters }, { id, productId }) {
    const products = rootGetters['rater/products'];
    const product = products
      .find(({ id: pId }) => pId === productId)
      || {};
    const path = `subscriptions/${id}/download?filters=type:eq:POLICY`;
    const name = `Contrat ${product.name}`;
    return downloadFromUrl({ path, name });
  },
  async downloadCertificate({ rootGetters }, { id, productId }) {
    const products = rootGetters['rater/products'];
    const product = products
      .find(({ id: pId }) => pId === productId)
      || {};
    const path = `subscriptions/${id}/download?filters=type:in:(CERTIFICATE%7C%7CCERTIFICATE_ACI)`;
    const name = `Attestation ${product.name}`;
    return downloadFromUrl({ path, name });
  },
  findSignatureUrlFromId(unset, signatureId) {
    return _findSignatureUrlFromId(signatureId);
  },
  downloadSubscriptionPreview(unused, subscriptionId) {
    const path = `subscriptions/${subscriptionId}/preview`;
    const name = 'Devis Assurup';
    return downloadFromUrl({ path, name });
  },
  downloadInvoiceItemPreview(unused, invoiceItemId) {
    const path = `invoicesitems/${invoiceItemId}/preview`;
    const name = 'Facture';
    return downloadFromUrl({ path, name });
  },
  downloadPaymentPreview(unused, paymentId) {
    const path = `payments/${paymentId}/preview`;
    const name = 'Paiement';
    return downloadFromUrl({ path, name });
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_VALUE_WITH_PATH(state, { value, path }) {
    set(state, path, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
